import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1n": "#000000",
    "col2n": "#FFFFFF"
}
function LegPan036({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M62.85 22.35q2.35-7.95 0-16.1Q31.6 6.3.85.2.6.1.35.1.2.05.1.05.05 0 0 0q0 .05.05.1v19.5q.35-.1.7-.15h.1q32.4-5.15 62 2.9z"
                    id="LegPan036__Symbol_85_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2n}
                    d="M62.85 0q-.2.05-.35.1Q31 6.2 0 6.25v16.1q29.7-8.1 62.3-2.85.15 0 .3.05.15 0 .25.05V.05L62.9 0h-.05z"
                    id="LegPan036__Symbol_86_0_Layer0_0_FILL"
                />
            </defs>
            <use
                xlinkHref="#LegPan036__Symbol_85_0_Layer0_0_FILL"
                transform="translate(129.65 310.25)"
                id="LegPan036__col1n"
            />
            <use
                xlinkHref="#LegPan036__Symbol_86_0_Layer0_0_FILL"
                transform="translate(192.5 310.25)"
                id="LegPan036__col2n"
            />
        </g></g>
    )
}
export default LegPan036
